import { NgModule } from '@angular/core';
import { MultilineInputComponent } from './multiline-input.component';
import { FormsModule } from '@angular/forms';
import { IconModule } from '../../icon/icon.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [MultilineInputComponent],
    exports: [MultilineInputComponent],
    imports: [FormsModule, IconModule, MatIconModule],
})
export class MultilineInputComponentModule {
}